(function() {
  document.addEventListener('DOMContentLoaded', function() {
    let isMobile = /Android|iPhone/i.test(navigator.userAgent) || false;

    // About page slideshows
    const slideshows = document.querySelectorAll('.about-slideshow');
    const sections = document.querySelectorAll('.about-link-section');

    sections.length ? sections[0].classList.add('about-hero') : false;
  
    if (slideshows.length && sections.length) {
      slideshows.forEach((slideshow) => {
        const slideshowSectionHandle = slideshow.dataset.sectionHandle;
        const sectionParent = document.querySelector('[data-section-handle="' + slideshowSectionHandle + '"] .hover-sliders__wrapper');
        if (sectionParent) {
          sectionParent.appendChild(slideshow);
        }
      });
  
      sections.forEach((section) => {
        const firstSlideshow = section.querySelector('.about-slideshow');
        firstSlideshow ? firstSlideshow.classList.add('active') : console.log('No slideshows in ' + section.getAttribute('id'));
        const hoverLinks = section.querySelectorAll('.hover-link[data-link-handle]');
  
        if (!isMobile) {
          hoverLinks.forEach((hoverLink) => {
            hoverLink.addEventListener("mouseenter", (event) => {
              const slideshowToShow = section.querySelector('.about-slideshow[data-link-handle="' + event.target.dataset.linkHandle + '"]')
    
              if (slideshowToShow) {
                hoverLinks.forEach((el) => el.classList.remove('active'));
                hoverLink.classList.add('active');
    
                Array.from(section.querySelectorAll('.about-slideshow')).forEach((el) => el.classList.remove('active'));
    
                section.querySelector('.about-slideshow[data-link-handle="' + event.target.dataset.linkHandle + '"]').classList.add('active');
                window.dispatchEvent(new Event('resize'));
              } else {
                console.log('No slideshow to show');
              }
    
            });
          });
        }
      });
    }

    // Register form
    if (document.getElementById('become-a-member')) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const urlEmail = urlParams.get('email');
      const storageEmail = sessionStorage.getItem('email');

      const registerForm = urlEmail || storageEmail ? document.getElementById('create_customer') : '';
      const formField = registerForm ? registerForm.querySelector('input[type="email"]') : '';

      if (urlEmail) {
        formField.value = urlEmail;
        registerForm.querySelector('input[type="password"]').focus();
      } else if (!urlEmail && storageEmail) {
        formField.value = decodeURIComponent(storageEmail);
        registerForm.querySelector('input[type="password"]').focus();
      } else {
        return false;
      }
    }

    // Klaviyo event listener moved to theme.liquid due to script race condition

    // Red buttons with loader animation
    const buttonsWithLoader = document.querySelectorAll('.wrapper--btn-loader');
    buttonsWithLoader.forEach((wrapper)=>{
      wrapper.querySelector('.loader').classList.remove('loader--spin');

      const btn = wrapper.querySelector('.btn');
      btn.addEventListener('click', ()=>{
        wrapper.querySelector('.loader').classList.add('loader--spin');
      });
    });

    // Membership bar
    function barStatus(barCookie) {
      return barCookie === "membership-bar";
    }
  
    const membershipBarWrapper = document.getElementById('membership-bar') || false;
    const toggleBar = membershipBarWrapper ? membershipBarWrapper.querySelector('.toggle-bar-btn') : false;
    let isBarClosed = document.cookie.split('; ').find(barStatus) ? true : false;
    
    if (isBarClosed) {
      if (membershipBarWrapper) {
        membershipBarWrapper.classList.toggle('bar--closed');
        const klaviyoBar = document.getElementsByClassName('klaviyo-form-WcB7Mz');
        klaviyoBar[0].style.animation = 'unset';
      }
    }
    
    if (membershipBarWrapper && toggleBar) {
      toggleBar.addEventListener('click', ()=>{
        membershipBarWrapper.classList.toggle('bar--closed');
        document.cookie = 'membership-bar; path=/;';
        if (!membershipBarWrapper.classList.contains('bar--closed')) {
          document.cookie = 'membership-bar; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
        }

        const klaviyoBar = document.getElementsByClassName('klaviyo-form-WcB7Mz');
        klaviyoBar[0].style.animation = 'unset';
      });
    }

  });
}());